<script lang="ts">
    import type { Page } from '~/jet/models';
    import { onMount } from 'svelte';

    // Page Components
    import DefaultPage from '~/components/pages/DefaultPage.svelte';
    import ListPage from '~/components/pages/ListPage.svelte';
    import EmptyPage from '~/components/pages/EmptyPage.svelte';
    import MetaTags from '~/components/structure/MetaTags/MetaTags.svelte';
    import SearchPage from '~/components/pages/SearchPage.svelte';

    // Stores
    import { setLibraryStates } from '~/stores/local-library-state';

    // Utils
    import { isSearchPage } from '@jet-app/music-classical/models/pages/search';

    export let page: Page;

    onMount(() => {
        // On page types that have CloudButtons in the page header, we query
        // the userComponents endpoint to determine if we need to render a
        // context menu in the header.  Any library state entitites received
        // as a result of that call are passed to the client in the Page object
        // to eliminiate the need to duplicate an API call when CloudButtons mounts.
        // If these entities exist in the Page object, update the library state store.
        if (page.header?.entities) {
            setLibraryStates(page.header.entities);
        }
    });
</script>

<MetaTags {page} />

{#if page.pageKind === 'emptyScreen'}
    <EmptyPage {page} />
{:else if page.pageKind == 'listScreen'}
    <ListPage {page} />
{:else if isSearchPage(page)}
    <SearchPage {page} />
{:else}
    <DefaultPage {page} />
{/if}
